module.exports = __webpack_public_path__ + "img/logo-company-8.f242208a.png";